export class LineRequest {
    Name: string;
    Label: string;
    Operat: any;
    DefaultValue: string;
    Visible: boolean;
    Search: boolean;
    Field: string;
    ListOperators: any[];
    Type: string;
    noligne: number;
    DisplayDefault: boolean;
    ListActionDate: any[];

    public Clear() {
        this.Name = '';
        this.Label = '';
        this.Operat = null;
        this.DefaultValue = '';
        this.Visible = true;
        this.Search = true;
        this.Field = '';
        this.Type = '';
        this.ListOperators = [];
        this.noligne = 0;
        this.DisplayDefault = true;
        this.ListActionDate = [];
    }

    public loadOperator(atype, aoperatorlist) {
        for (let i = 0; i < aoperatorlist.length; i++) {
            if (this.getAddOperator(atype, aoperatorlist[i].type) === true) {
                this.ListOperators.push({
                    label: aoperatorlist[i].name,
                    value: aoperatorlist[i].id,
                });
            }
        }
    }

    private getAddOperator(aType, aOperator) {
        if (
            (aType === 'DateTime' ||
                aType === 'Date' ||
                aType === 'Integer' ||
                aType === 'Double' ||
                aType === 'Boolean') &&
            (aOperator === 'TLike' || aOperator === 'TNotLike' || aOperator === 'TIn' || aOperator === 'TNotIn')
        ) {
            return false;
        } else {
            return true;
        }
    }
}
